import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import inspiry from "../../Assets/inspiry.jpg";
import embraceAi from "../../Assets/embrace-ai.jpg";
import photoshop from "../../Assets/photoshop-manipulation.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={embraceAi}
              title="Embrace AI"
              description="This image shows the importance of embracing AI using only AI from Midjourney and Photoshop Generator Fill"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={photoshop}
              title="Photoshop Manipulation"
              description="This photo shows my expertise in both Photoshop and photography to make a fictional scene."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={inspiry}
              title="Inspiry Podcast Thumbnail"
              description="After creating Inspiry Podcast brand identity, I worked on thumbnails that convey its identity."         
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
